import { t } from 'i18next';
import { observer } from 'mobx-react';

import { useMeasurement } from '@/hooks/useMeasurement';
import { CompressorActivityStateEnum } from '@/constants/enums';
import { useStores } from '@/hooks/use-stores';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';
import { useDewPointValue } from '@/comp/MapBuilder/nodes/desiccantAirDryer/DessicantMapView/DesiccantMapView.utils';
import unitsEnum from '@/constants/unitsEnum';

import Slider from '../Slider/Slider';

const DesiccantAirDryerSliders = observer(({ entity }: { entity: Entity }) => {
  const { tvalue, tunit } = useMeasurement();
  const { stationStore } = useStores();
  const {
    connectivity,
    activity,
    dewpointTemperatureCelsius,
    dryerTemperatureTargetCelsius,
    dryerTemperatureSetpointCelsius,
  } = entity;
  const onDevices = stationStore.currentStation?.devices?.filter(device => entity.onDevices.includes(device.deviceId));

  const dewPoint = useDewPointValue(dewpointTemperatureCelsius, onDevices);
  const sliderPoints = [
    { label: t('target'), value: dryerTemperatureTargetCelsius, isTarget: true },
    { label: t('Set point'), value: dryerTemperatureSetpointCelsius },
  ];

  return (
    <div className="main-slider">
      <Slider
        showTierLock
        title={t('dew point')}
        value={dewPoint}
        unit={t(tunit('°C'))}
        min={tvalue(-80, unitsEnum.celsius)}
        max={tvalue(0, unitsEnum.celsius)}
        points={sliderPoints}
        connectivity={connectivity}
        highlightSlider={activity?.toLowerCase() === CompressorActivityStateEnum.Load}
        addSideGaps
        hasTarget
      />
    </div>
  );
});

export default DesiccantAirDryerSliders;
